import {
  AnnouncementCard,
  AnnouncementData,
  AnnouncementDetailData,
  AnnouncementMetrics,
  SaveAnnouncementData,
} from '@/api/announcements/types';

export const USE_MOCK = true;

const ELIGIBLE_USERS = 1250;

let nextAnnouncementId = 100;
let nextCardId = 1000;

function buildCards(
  cards: Pick<
    AnnouncementCard,
    'title' | 'description' | 'video_url' | 'image_url'
  >[]
): AnnouncementCard[] {
  return cards.map((card, index) => {
    nextCardId += 1;
    return { ...card, id: nextCardId, position: index + 1 };
  });
}

function buildMetrics(viewed: number, completed: number): AnnouncementMetrics {
  const viewLater = viewed > 0 ? Math.round((viewed - completed) * 0.7) : 0;
  return {
    eligible: ELIGIBLE_USERS,
    viewed,
    completed,
    view_later: viewLater,
    not_viewed: ELIGIBLE_USERS - viewed,
  };
}

const defaultCards = [
  {
    title: 'Nova funcionalidade de laudos',
    description:
      '<p>Agora você pode gerar laudos com ' +
      '<strong>IA em poucos segundos</strong>. ' +
      'Economize tempo e aumente sua produtividade. ' +
      '<a href="https://proto.com.br/laudos" ' +
      'target="_blank" rel="noopener noreferrer">Saiba mais</a>.</p>',
    video_url: 'https://youtube.com/@proto.oficial/videos',
    image_url: null,
  },
  {
    title: 'Integração com mapas melhorada',
    description:
      '<p>Visualize todas as suas amostras no mapa com:</p>' +
      '<ul><li>Filtros avançados</li><li>Marcações personalizadas</li></ul>',
    video_url: null,
    image_url: null,
  },
  {
    title: 'Relatórios mais completos',
    description:
      '<p>Os relatórios agora incluem <em>gráficos comparativos</em> e ' +
      'análise de tendências do mercado.</p>',
    video_url: null,
    image_url: null,
  },
];

function buildAnnouncement(
  data: Omit<AnnouncementData, 'cards_count'>,
  cardsCount: number
): AnnouncementDetailData {
  const cards = buildCards(defaultCards.slice(0, cardsCount));
  return {
    ...data,
    cards_count: cards.length,
    cards,
    metrics: buildMetrics(data.viewed, data.completed),
  };
}

const store: AnnouncementDetailData[] = [
  buildAnnouncement(
    {
      id: 1,
      title: 'Novidades da versão 2.5',
      status: 'active',
      created_at: '2026-01-04T10:00:00Z',
      published_at: '2026-01-04T14:00:00Z',
      viewed: 847,
      completed: 623,
    },
    3
  ),
  buildAnnouncement(
    {
      id: 2,
      title: 'Atualização de segurança',
      status: 'draft',
      created_at: '2026-06-28T09:30:00Z',
      published_at: null,
      viewed: 0,
      completed: 0,
    },
    2
  ),
  buildAnnouncement(
    {
      id: 3,
      title: 'Novo fluxo de vistorias',
      status: 'draft',
      created_at: '2026-06-15T16:20:00Z',
      published_at: null,
      viewed: 0,
      completed: 0,
    },
    3
  ),
  buildAnnouncement(
    {
      id: 4,
      title: 'Melhorias no laudo estatístico',
      status: 'draft',
      created_at: '2026-05-10T11:00:00Z',
      published_at: null,
      viewed: 0,
      completed: 0,
    },
    1
  ),
  buildAnnouncement(
    {
      id: 5,
      title: 'Novidades da versão 2.4',
      status: 'inactive',
      created_at: '2025-11-20T10:00:00Z',
      published_at: '2025-11-22T09:00:00Z',
      viewed: 912,
      completed: 704,
    },
    3
  ),
  buildAnnouncement(
    {
      id: 6,
      title: 'Boas vindas 2026',
      status: 'inactive',
      created_at: '2025-12-28T08:00:00Z',
      published_at: '2026-01-02T08:00:00Z',
      viewed: 1043,
      completed: 987,
    },
    1
  ),
  buildAnnouncement(
    {
      id: 7,
      title: 'Integração com Google Agenda',
      status: 'inactive',
      created_at: '2025-10-05T14:45:00Z',
      published_at: '2025-10-06T10:00:00Z',
      viewed: 655,
      completed: 402,
    },
    2
  ),
  buildAnnouncement(
    {
      id: 8,
      title: 'Novidades da versão 2.3',
      status: 'inactive',
      created_at: '2025-08-18T13:00:00Z',
      published_at: '2025-08-19T09:00:00Z',
      viewed: 789,
      completed: 555,
    },
    3
  ),
  buildAnnouncement(
    {
      id: 9,
      title: 'Nova central de notificações',
      status: 'inactive',
      created_at: '2025-07-01T10:30:00Z',
      published_at: '2025-07-02T08:00:00Z',
      viewed: 601,
      completed: 480,
    },
    2
  ),
  buildAnnouncement(
    {
      id: 10,
      title: 'Atualização de planos e créditos',
      status: 'inactive',
      created_at: '2025-06-10T15:00:00Z',
      published_at: '2025-06-11T09:00:00Z',
      viewed: 720,
      completed: 512,
    },
    3
  ),
  buildAnnouncement(
    {
      id: 11,
      title: 'Melhorias no upload de fotos',
      status: 'inactive',
      created_at: '2025-05-02T09:00:00Z',
      published_at: '2025-05-03T08:00:00Z',
      viewed: 534,
      completed: 398,
    },
    2
  ),
  buildAnnouncement(
    {
      id: 12,
      title: 'Novidades da versão 2.2',
      status: 'inactive',
      created_at: '2025-04-01T10:00:00Z',
      published_at: '2025-04-02T09:00:00Z',
      viewed: 812,
      completed: 590,
    },
    3
  ),
];

function toCards(data: SaveAnnouncementData): AnnouncementCard[] {
  return data.cards.map((card, index) => {
    if (!card.id) nextCardId += 1;
    return {
      id: card.id ?? nextCardId,
      title: card.title,
      description: card.description,
      video_url: card.video_url,
      image_url: card.image_url,
      position: index + 1,
    };
  });
}

function deactivateCurrentActive(): void {
  const active = store.find((item) => item.status === 'active');
  if (active) active.status = 'inactive';
}

export function listMockAnnouncements(): AnnouncementData[] {
  return store.map((item) => ({
    id: item.id,
    title: item.title,
    status: item.status,
    cards_count: item.cards.length,
    created_at: item.created_at,
    published_at: item.published_at,
    viewed: item.viewed,
    completed: item.completed,
  }));
}

export function getMockAnnouncement(
  id: number
): AnnouncementDetailData | undefined {
  const found = store.find((item) => item.id === id);
  if (!found) return undefined;
  return { ...found, cards: [...found.cards], metrics: { ...found.metrics } };
}

export function getActiveMockAnnouncement(): AnnouncementData | undefined {
  return store.find((item) => item.status === 'active');
}

export function createMockAnnouncement(
  data: SaveAnnouncementData
): AnnouncementDetailData {
  nextAnnouncementId += 1;
  const announcement: AnnouncementDetailData = {
    id: nextAnnouncementId,
    title: data.title,
    status: 'draft',
    cards_count: data.cards.length,
    created_at: new Date().toISOString(),
    published_at: null,
    viewed: 0,
    completed: 0,
    cards: toCards(data),
    metrics: buildMetrics(0, 0),
  };
  store.push(announcement);
  return announcement;
}

export function updateMockAnnouncement(
  id: number,
  data: SaveAnnouncementData
): void {
  const found = store.find((item) => item.id === id);
  if (!found) return;
  found.title = data.title;
  found.cards = toCards(data);
  found.cards_count = found.cards.length;
}

export function deleteMockAnnouncement(id: number): void {
  const index = store.findIndex((item) => item.id === id);
  if (index >= 0) store.splice(index, 1);
}

export function publishMockAnnouncement(id: number): void {
  const found = store.find((item) => item.id === id);
  if (!found) return;
  deactivateCurrentActive();
  found.status = 'active';
  found.published_at = new Date().toISOString();
  found.viewed = 0;
  found.completed = 0;
  found.metrics = buildMetrics(0, 0);
}

export function activateMockAnnouncement(id: number): void {
  const found = store.find((item) => item.id === id);
  if (!found) return;
  deactivateCurrentActive();
  found.status = 'active';
  if (!found.published_at) found.published_at = new Date().toISOString();
}

export function deactivateMockAnnouncement(id: number): void {
  const found = store.find((item) => item.id === id);
  if (!found) return;
  found.status = 'inactive';
}

export function convertMockAnnouncementToDraft(id: number): void {
  const found = store.find((item) => item.id === id);
  if (!found) return;
  found.status = 'draft';
}
